import { CustomSelect, Uploader, Button } from "../../../components";
import React, { useEffect, useRef, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../../../store";
import { useClickOutside } from "../../../utils";
import {
  updateFileProgress,
  addFile,
  setUploadedSuccessfully,
} from "@/store/upload/upload.slice";
import { toast } from "../../../components";
import { callRegisterMediaOnCms } from "@/store/upload/upload.action";
import { getSubtitleList } from "@/store/media/media.action";
import { setSubtitleList } from "@/store/media/media.slice";
import { updateSubtitleList } from "@/store/media/media.action";
import { Form } from "react-bootstrap";

const MediaSubtitle = ({
  updateFileProgress,
  addFile,
  setUploadedSuccessfully,
  callRegisterMediaOnCms,
  currentMediaDetails,
  getSubtitleList,
  subtitleList,
  setSubtitleList,
  updateSubtitleList,
  bunchLanguageList,
}: Props) => {
  const [selectedLanguage, setSelectedLanguage] = useState<any>(subtitleList);
  const [showAddLanguage, setShowAddLanguage] = useState<boolean>(false);
  const [showMoreOptions, setShowMoreOptions] = useState<boolean>(false);
  const moreOptionsRef = useRef<HTMLDivElement>(null);
  const [lang, setLang] = useState<any>("");
  const [subtitleFile, setSubtitleFile] = useState<File | null>(null);
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const [file, setFile] = useState<any>(null);
  const [showRemove, setShowRemove] = useState(false);
  const [assetId, setAssetId] = useState(null);
  const uploadingRef = useRef(false);
  const uploadingRefId = useRef("");
  const UploadCallback = useRef<any>(null);
  const [threeDotId, setThreeDotId] = useState<string>("");
  const [loadingStates, setLoadingStates] = useState<{ [key: string]: number }>(
    {}
  );
  const [fadeOutStates, setFadeOutStates] = useState<{
    [key: string]: boolean;
  }>({});
  const loadingIntervals = useRef<{ [key: string]: NodeJS.Timeout }>({});
  const [error, setError] = useState<string | null>(null);
  const [langError, setLangError] = useState<string | null>(null);
  const [isUpdating, setIsUpdating] = useState<boolean>(false);

  useEffect(() => {
    subtitleList?.forEach((subtitle: any) => {
      if (
        subtitle.status === 1 &&
        !loadingIntervals.current[subtitle.subtitle_id]
      ) {
        // Start loading animation
        setLoadingStates((prev) => ({ ...prev, [subtitle.subtitle_id]: 0 }));
        setFadeOutStates((prev) => ({
          ...prev,
          [subtitle.subtitle_id]: false,
        }));

        // Animate to 70%
        loadingIntervals.current[subtitle.subtitle_id] = setInterval(() => {
          setLoadingStates((prev) => {
            const current = prev[subtitle.subtitle_id] || 0;
            if (current < 90) {
              return { ...prev, [subtitle.subtitle_id]: current + 1 };
            }
            return prev;
          });
        }, 50);
      } else if (
        subtitle.status === 3 &&
        loadingIntervals.current[subtitle.subtitle_id]
      ) {
        // Clear interval and animate to 100%
        clearInterval(loadingIntervals.current[subtitle.subtitle_id]);
        delete loadingIntervals.current[subtitle.subtitle_id];

        // Set to 100% immediately
        setLoadingStates((prev) => ({ ...prev, [subtitle.subtitle_id]: 100 }));

        // Wait for 1 second to show 100% completion before fading out
        setFadeOutStates((prev) => ({ ...prev, [subtitle.subtitle_id]: true }));
        setIsUpdating(false);
      }
    });

    return () => {
      // Cleanup intervals on unmount
      Object.values(loadingIntervals.current).forEach((interval) =>
        clearInterval(interval)
      );
    };
  }, [subtitleList]);

  const handleAddLanguage = () => {
    setShowAddLanguage(!showAddLanguage);
  };

  const handleMoreOptionsToggle = (id: string) => {
    setShowMoreOptions(!showMoreOptions);
    setThreeDotId(id);
  };

  useEffect(() => {
    if (subtitleList.length === 0) {
      if (currentMediaDetails?.id) {
        getSubtitleList({ id: currentMediaDetails?.id });
      }
    }
  }, [currentMediaDetails]);

  useClickOutside(moreOptionsRef, () => handleMoreOptionsToggle(""));

  const handleCreateSubtitle = () => {
    if (currentMediaDetails?.id) {
      if (selectedFile) {
        const data = {
          file,
          name: "subtitle",
          media: currentMediaDetails?.id,
          asset_id: assetId,
          damid: currentMediaDetails?.damid,
          subtitle: lang,
          language: lang,
          enabled: true,
          default: false,
        };
        callRegisterMediaOnCms(data, (response: any) => {
          if (response && response.status === 200) {
            uploadingRefId.current = response?.data?.id;
            const id = response.data.id;
            const token = response.data.jwt;
            const query = {
              entity: currentMediaDetails?.damid,
              key: "subtitles",
              method: "subtitles.register",
            };
            UploadCallback.current && UploadCallback.current(query, token);
            setSelectedLanguage([
              ...selectedLanguage,
              {
                language: lang,
                file_info: selectedFile,
                id: response.data.id,
              },
            ]);
            setSubtitleList({
              data: {
                list: [...subtitleList, response.data],
              },
            });
            setShowAddLanguage(false);
            setLang("");
            setSelectedFile(null);
            setShowRemove(false);
          } else {
            toast.fail("");
          }
        });
      } else {
        const data = {
          language: lang,
          file_info: subtitleFile,
          id: lang + new Date().getTime(),
        };
        setSelectedLanguage([...selectedLanguage, data]);
        setShowAddLanguage(false);
        setLang("");
        setSubtitleFile(null);
      }
    }
  };

  const handleThreeDotAction = (option: string, id: string) => {
    if (option === "delete") {
      setShowMoreOptions(false);
      setSelectedLanguage(
        selectedLanguage.filter((language: any) => language.id !== id)
      );
    } else if (option === "edit") {
      setShowMoreOptions(false);
      setSelectedLanguage(
        selectedLanguage.filter((language: any) => language.id !== id)
      );
    } else if (option === "upload") {
      setShowMoreOptions(false);
      setSelectedLanguage(
        selectedLanguage.filter((language: any) => language.id !== id)
      );
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      setSubtitleFile(event.target.files[0]);
    }
  };

  const handleReset = () => {
    setShowRemove(false);
    setSelectedFile(null);
    setSubtitleFile(null);
  };

  const onFileEvent = (event: string, data: any, cb?: any): any => {
    if (event === "fileAdded") {
      setError(null);
      const file = data.file;
      file.type = "subtitle";
      file.name = file.fileName;
      file.isShorts = false;
      file.asset_id = assetId;
      setSelectedFile(file);
      setFile(file);
      setShowRemove(true);

      callRegisterMediaOnCms(file, (response: any) => {
        if (response && response.status === 200) {
          const token = response.data.jwt;
          const query = {
            entity: currentMediaDetails.id,
            key: "subtitle",
          };
          cb && cb(query, token);
        } else {
          toast.fail("");
        }
      });

      UploadCallback.current = cb;
      // showUploadProgress();

      addFile({
        key: file.uniqueIdentifier,
        file: {
          id: file.uniqueIdentifier,
          name: file.fileName,
          identifier: file.uniqueIdentifier,
          progress: 0,
          isUploadedSuccessfully: false,
          type: "subtitle",
          error: null,
        },
      });
    } else if (event === "fileProgress") {
      const file = data.file;
      const progress = Math.round(file.progress(false) * 1000) / 10;
      updateFileProgress({
        identifier: file.uniqueIdentifier,
        progress: progress,
      });
    } else if (event === "fileSuccess") {
      uploadingRef.current = false;
      const response = JSON.parse(data.response);

      setAssetId((prev) => {
        return response.data.id;
      });

      setUploadedSuccessfully({
        identifier: data.id,
        flag: true,
      });
    } else if (event === "fileError") {
      uploadingRef.current = false;
      setError(data.error);
      toast.fail(data.error);
      updateFileProgress({
        identifier: data.file.uniqueIdentifier,
        progress: 0,
      });
    }
  };

  return (
    <div className="w-100">
      <div className="subHeader d-flex justify-content-between align-items-center px-3 py-2">
        <h5>SUBTITLES </h5>
      </div>
      <div className="w-100">
        <div className=" d-flex flex-row justify-content-between align-items-center m-3 p-2 border-bottom">
          <span className="fw-bold"> Language</span>
          <span className="fw-bold">Actions</span>
        </div>
        {subtitleList?.map((language: any) => (
          <>
            <div
              key={language.id}
              className=" d-flex flex-row justify-content-between align-items-center m-3 p-2 border-bottom position-relative"
            >
              <div>
                <span>{language.language}</span>
                {(language.status === 1 || language.status === 3) &&
                  !fadeOutStates[language.id] && (
                    <div
                      className="progress mt-2"
                      style={{
                        position: "absolute",
                        width: "100%",
                        height: "2px",
                        top: "29px",
                        left: "0",
                        opacity: fadeOutStates[language.id] ? 0 : 1,
                        transition: "opacity 0.5s ease-out",
                      }}
                    >
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{
                          width: `${loadingStates[language.id] || 0}%`,
                          transition: "width 0.3s ease-out",
                        }}
                        aria-valuenow={loadingStates[language.id] || 0}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      />
                    </div>
                  )}
                {language.status === -1 && (
                  <span
                    className="text-danger"
                    style={{ fontSize: "11px", marginLeft: "10px" }}
                  >
                    {/* <i className="bi bi-exclamation-triangle"></i> */}
                    Error while uploading subtitle
                  </span>
                )}
              </div>

              <div>
                {language.status !== -1 && (
                  <Form.Check
                    type="switch"
                    id={language.subtitle_id}
                    label={language.enabled ? "Enabled" : "Disabled"}
                    checked={language.enabled}
                    disabled={language.status !== 3 || isUpdating}
                    onChange={() => {
                      setIsUpdating(true);
                      const { status, ...restLanguage } = language;
                      updateSubtitleList({
                        ...restLanguage,
                        enabled: !language.enabled,
                      });
                    }}
                  />
                )}
                {/* <div>
                  <MoreVert
                    onClick={() => handleMoreOptionsToggle(language.id)}
                    style={{ transform: 'rotate(90deg)' }}
                  />
                  {showMoreOptions && threeDotId === language.id && (
                    <div
                      ref={moreOptionsRef}
                      style={{
                        position: 'absolute',
                        width: '100px',
                        right: '0',
                        backgroundColor: 'rgba(255, 255, 255)',
                        borderRadius: '5px',
                        zIndex: 1000,
                      }}
                    >
                      <ul className="p-0 m-0 bg-light rounded py-1" style={{ listStyle: 'none' }}>
                        {options.map((option) => {
                          return (
                            <li
                              className="px-3 py-1 pointer"
                              key={option}
                              data-value={option}
                              onClick={() => handleThreeDotAction(option, language.id)}
                            >
                              <span className="text-capitalize">{option}</span>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                </div> */}
              </div>
            </div>
          </>
        ))}
        <div className="m-3">
          <button onClick={handleAddLanguage} className="btn btn-primary">
            Add New
          </button>

          <div>
            {showAddLanguage && (
              <div className="d-flex flex-row gap-4 align-items-end mt-3">
                <div className="d-flex flex-column">
                  <div
                    style={{ width: "250px", position: "relative" }}
                    className="col-md-4 mt-0"
                  >
                    <CustomSelect
                      label="Language"
                      value={lang}
                      handleChange={(newValue: any) => {
                        setLang(newValue.value);
                        subtitleList.forEach((subtitle: any) => {
                          if (
                            subtitle.language === newValue.value &&
                            subtitle.status !== -1
                          ) {
                            setLangError("Language already exists");
                          }
                        });
                        if (langError) {
                          setLangError(null);
                        }
                      }}
                      options={bunchLanguageList.map((language: any) => ({
                        label: language.name,
                        value: language.name,
                      }))}
                      showRequired={true}
                      updatedOptions={bunchLanguageList.map(
                        (language: any) => ({
                          label: language.name,
                          value: language.name,
                        })
                      )}
                      hideArrow={true}
                    />
                  </div>
                  {langError && (
                    <span
                      style={{
                        position: "absolute",
                        bottom: "0",
                        left: "15px",
                      }}
                      className="text-danger"
                    >
                      {langError}
                    </span>
                  )}
                </div>
                <div className="d-flex flex-column " style={{ maxWidth: 300 }}>
                  <div
                    className="d-flex align-items-start gap-2 mt-0"
                    style={{ position: "relative" }}
                  >
                    {!showRemove ? (
                      <Uploader
                        id={"subtitle"}
                        onFileEvent={onFileEvent}
                        datatype={"SUBTITLE"}
                        disabled={lang === "" || langError !== null}
                      >
                        <div
                          className="d-flex align-items-center gap-1 border rounded px-2 py-1"
                          style={{
                            cursor: "pointer",
                            maxWidth: 200,
                            minWidth: 200,
                          }}
                        >
                          <button
                            className="bg-white d-flex flex-column gap-1 align-items-center text-secondary border-0 fs-6"
                            style={{ borderRight: "1px solid #ddd" }}
                          >
                            Browse
                            <div className="d-flex align-items-center gap-2">
                              <i className="bi bi-upload"></i>
                              <span className="text-muted small">
                                Choose file
                              </span>
                            </div>
                          </button>
                          <div
                            className="text-danger"
                            style={{
                              position: "absolute",
                              bottom: "-16px",
                              left: "0",
                            }}
                          >
                            {error}
                          </div>
                        </div>
                      </Uploader>
                    ) : (
                      <div className="d-flex align-items-center gap-2">
                        <div
                          className="border rounded p-2"
                          style={{ maxWidth: 200, minWidth: 200 }}
                        >
                          <span>
                            {selectedFile?.fileName || subtitleFile?.name}
                          </span>
                        </div>
                        <Button type="outline-primary" onClick={handleReset}>
                          Reset
                        </Button>
                      </div>
                    )}
                  </div>
                </div>

                <button
                  onClick={handleCreateSubtitle}
                  className={`btn ${
                    (selectedFile !== null || subtitleFile !== null) &&
                    lang !== "" &&
                    assetId !== null
                      ? "btn-primary"
                      : "btn-secondary"
                  } mb-1`}

                  // disabled={(selectedFile === null && subtitleFile === null) || lang === ''}
                >
                  CREATE
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapState = (state: RootState) => ({
  organizationList: state.constants.organizationList.list,
  metaLanguage: state.app.metaLanguage,

  currentMediaDetails: state.media.mediaDetails.media,
  subtitleList: state.media.subtitleList.list,
  bunchLanguageList: state.constants.bunchLanguageList.list,
});

const mapDispatch = {
  updateFileProgress,
  addFile,
  setUploadedSuccessfully,
  callRegisterMediaOnCms,
  getSubtitleList,
  setSubtitleList,
  updateSubtitleList,
};

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector>;
export default connector(MediaSubtitle);
